import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Table } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'

import { ThemeContext } from '../../../theme/ThemeContext'
import { Columns } from './Columuns'
import { Query } from './Query'
import styles from './order.module.css'
import {
  getreplaceMakeDetail,
  getreplaceMakeDetailAmount,
  getreplaceMakeOrderList,
} from '../OReplaceMakeSlice'
import { DateRangeType, getDateRange } from '../../../compnents/date/TimeSelect'
import moment from 'moment'
import { getChainListAsync } from '../../warehouseStatement/allReport/warehouseChangeReport/warehouseChangeReportSlice'

// 代煎明细详情
export const ReplaceMakeDetail = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [data, setData] = useState<any>([])

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [total, setTotal] = useState(0)

  const [head, tail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
    mergeFlag: 0,
    startTime: moment(head).format('YYYY-MM-DD HH:mm:ss'),
    endTime: moment(tail).format('YYYY-MM-DD HH:mm:ss'),
  })

  const [cellData, setCellData] = useState<any>({})

  const [chainList, setChainList] = useState<Array<any>>([])

  const [chainLoaded, setChainLoaded] = useState(false)

  // 总店获取机构名称列表，列表有值才展示机构名称查询条件
  useEffect(() => {
    dispatch(getChainListAsync())
      .then(unwrapResult)
      .then((res: any) => {
        setChainList(res || [])
      })
      .finally(() => {
        setChainLoaded(true)
      })
  }, [])

  useEffect(() => {
    // 等机构列表加载完成后再查询，确保总店判断准确
    if (!chainLoaded) {
      return
    }
    setPageLoading(true)
    dispatch(
      getreplaceMakeDetail({
        ...params,
        // 仅当当前机构是总店（与机构名称查询条件一致）且未选择具体机构时才传 isHeadquarters
        ...(chainList?.length && !params?.chainId
          ? { isHeadquarters: true }
          : {}),
        startTime: params?.startTime || head,
        endTime: params?.endTime || tail,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setTotal(res.total)
        setData(res.records)
      })
      .finally(() => {
        setPageLoading(false)
      })

    dispatch(
      getreplaceMakeDetailAmount({
        ...params,
        ...(chainList?.length && !params?.chainId
          ? { isHeadquarters: true }
          : {}),
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setCellData({
          sellNumber: res.sellNumber,
          totalCostFormat: res.totalCostFormat,
          sellAmountFormat: res.sellAmountFormat,
        })
      })
  }, [params, chainList, chainLoaded])

  // 代煎订单导出
  const onExport = () => {
    const param = {
      ...params,
      current: 1,
      size: 1000,
    }
    const theader = [
      '药品名称',
      '销售数量',
      '进价',
      '总成本',
      '销售单价',
      '销售总金额',
    ]
    const filterVal = [
      'materialsCatalogName',
      'sellNumber',
      'stockPrice',
      'totalCost',
      'unitPrice',
      'sellAmount',
    ]
    dispatch(
      getreplaceMakeDetail({
        ...param,
        // 仅当当前机构是总店（与机构名称查询条件一致）且未选择具体机构时才传 isHeadquarters
        ...(chainList?.length && !param?.chainId
          ? { isHeadquarters: true }
          : {}),
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const data = res.records
          .map((v: any) => ({
            ...v,
            totalCost:
              params?.mergeFlag == 1 && v.totalCost == 0
                ? '-'
                : v.totalCost == -1
                ? '-'
                : v.totalCost.toFixed(2),
            sellAmount:
              params?.mergeFlag == 1 && v.sellAmount == 0
                ? '-'
                : v.sellAmount == -1
                ? '-'
                : v.sellAmount.toFixed(2),
            unitPrice:
              params?.mergeFlag == 1 && v.unitPrice == 0
                ? '-'
                : v.unitPrice == -1
                ? '-'
                : v.unitPrice.toFixed(5),
            stockPrice:
              params?.mergeFlag == 1 && v.stockPrice == 0
                ? '-'
                : v.stockPrice == -1
                ? '-'
                : v.stockPrice.toFixed(5),
          }))
          ?.map((s: any) => filterVal?.map((j: any) => s[j]))
        import('../../../ExportXLSX/Export2Excel').then((excel) => {
          excel.export_json_to_excel({
            header: theader,
            data,
            filename: '代煎明细',
            autoWidth: true,
          })
        })
      })
  }

  return (
    <Col
      style={{
        height: 'calc(100% - 0px) ',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Col
        style={{
          flex: 1,
          overflow: 'hidden',
          backgroundColor: theme.pn,
          marginTop: 10,
          borderRadius: 10,
          padding: '20px 15px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Query
          loading={pageLoading}
          chainList={chainList}
          onValueChange={(v) => {
            setParams({
              ...params,
              ...v,
              current: 1,
            })
          }}
          onExport={onExport}
        />
        <EditableList
          page={{
            items: data,
            current: params.current || 1,
            size: params.size || 10,
            total,
          }}
          loading={pageLoading}
          summary={() => (
            <Table.Summary fixed>
              <Table.Summary.Row className={styles.total}>
                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                <Table.Summary.Cell className={styles.footingTitle} index={1}>
                  合计
                </Table.Summary.Cell>
                <Table.Summary.Cell align='center' index={2}>
                  {cellData?.sellNumber}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}></Table.Summary.Cell>
                <Table.Summary.Cell align='center' index={4}>
                  {cellData?.totalCostFormat}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5}></Table.Summary.Cell>
                <Table.Summary.Cell index={6} align='center'>
                  {cellData?.sellAmountFormat}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
          style={{ color: theme.tc3 }}
          className={styles.table}
          columns={Columns(
            (params.size || 10) * ((params.current || 1) - 1),
            params?.mergeFlag
          )}
          onChangePage={(current: number, size?: number) => {
            setParams({
              ...params,
              current: current,
              size: size || 10,
            })
          }}
        />
      </Col>
    </Col>
  )
}
